var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIdentificationSignalsSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12102_26981)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12102_26981)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1825 4.52738V3.30519C11.1825 2.98105 11.0536 2.67018 10.8243 2.44098C10.5949 2.21177 10.2838 2.08301 9.95946 2.08301H2.62144C2.29708 2.08301 1.986 2.21177 1.75665 2.44098C1.52729 2.67018 1.39844 2.98105 1.39844 3.30519V7.58284C1.39844 7.90698 1.52729 8.21785 1.75665 8.44705C1.986 8.67626 2.29708 8.80502 2.62144 8.80502H7.51346",
  stroke: "#F35B22",
  strokeWidth: 1.04794,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12102_26981)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.28125 11.25V8.83008V10.755",
  stroke: "#F35B22",
  strokeWidth: 1.04794,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i_12102_26981)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.44531 11.25H7.50282",
  stroke: "#F35B22",
  strokeWidth: 1.04794,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_i_12102_26981)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3913 6.97217H11.1683C10.4929 6.97217 9.94531 7.51936 9.94531 8.19435V11.8609C9.94531 12.5359 10.4929 13.0831 11.1683 13.0831H12.3913C13.0668 13.0831 13.6143 12.5359 13.6143 11.8609V8.19435C13.6143 7.51936 13.0668 6.97217 12.3913 6.97217Z",
  stroke: "#F35B22",
  strokeWidth: 1.04794,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12102_26981",
  x: 0.875,
  y: 1.55908,
  width: 11.8761,
  height: 8.81796,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1.04794,
  dy: 1.04794
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.523969
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12102_26981"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12102_26981",
  x: 5.75781,
  y: 8.30615,
  width: 2.09481,
  height: 4.51571,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1.04794,
  dy: 1.04794
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.523969
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12102_26981"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i_12102_26981",
  x: 3.92188,
  y: 10.7261,
  width: 5.1495,
  height: 2.09579,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1.04794,
  dy: 1.04794
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.523969
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12102_26981"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i_12102_26981",
  x: 9.42188,
  y: 6.44824,
  width: 5.76669,
  height: 8.20663,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1.04794,
  dy: 1.04794
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.523969
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12102_26981"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12102_26981"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(0.5)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIdentificationSignalsSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";